import UserAvatar from "../../common/UserAvatar";
import Username from "../../common/Username";
import HtmlParsedText from "../../common/HtmlParsedText";
import PostActionButtons from "../../Post/section/PostActionButtons";
import {convertReactionUsersToReactionData} from "../../../utils/user";

const CommentUser = ({post}) => {
	return (
		<a href={post.User ? post.User.view_url : '#'} title={post.username}
		   className="block w-[24px] h-[24px]">
			<UserAvatar user={post.User}/>
		</a>
	)
}

const CommentHeader = ({post}) => {
	return (
		<div className="flex items-center text-sm text-url">
			<Username user={post.User} />
		</div>
	);
}

const Comment = ({post, postId}) => {
	return (
		<div className={`flex flex-wrap rounded-lg ${post.is_deleted && 'is-deleted'}`}>
			<div className="block w-[32px] text-center gap-x-2 p-2 flex-shrink-0 flex-grow-0">
				<CommentUser post={post} />
			</div>

			<div className="flex-1 p-2 min-w-0">
				<div className="flex flex-col h-full">
					<div className="mb-2">
						<CommentHeader post={post} />
					</div>

					<div className="relative h-auto flex-grow flex-shrink">
						<div className={`text-white ${post.is_deleted && 'line-through opacity-65'}`}>
							<HtmlParsedText text={post.message_parsed} isPostContent={true}/>
						</div>
					</div>

					<div>
						<PostActionButtons
							post={post}
							postId={postId}
							canReact={post.can_react}
							initialReactionsData={convertReactionUsersToReactionData(Object.values(post.reaction_users))}
							initialReactionScore={Object.values(post.reaction_users).length}
							isReactedTo={post.is_reacted}
							isMini={true}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Comment;